import styled, { css } from 'styled-components';
import { clearFix } from 'polished';

import {
  colors,
  layers,
  typography,
} from '../../theme';

import {
  TagBox,
} from '../../elements';

export const Wrapper = styled.div`
  ${typography.BODY__SMALL}
  top: 0;
  padding: ${10 / typography.BASE_FONT_SIZE}rem;
  position: fixed;
  right: 0;
  transition: opacity .2s ease-in-out,
              visibility .2s ease-in-out;
  z-index: ${layers.SHARING};

  @media screen and (max-width: 666px) {
    display: none;
  }

  ${(props) => props.position === 'absolute' && css`
    bottom: auto;
    position: absolute;
    top: 0;
  `}

  ${(props) => props.position === 'fixed-top' && css`
    bottom: auto;
    position: fixed;
    top: 0;
  `}

  ${(props) => props.position === 'fixed-bottom' && css`
    bottom: 0;
    top: auto;
    position: fixed;
  `}

  &:hover {
    span {
      display: block;
    }
  }

  &.inactive {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
  }

  &.active {
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
  }
`;

export const ShareShow = styled.div`
  float: left;
`;

export const ShareHidden = styled.div`
  float: left;
  display: none;
`;

export const Box = TagBox.extend`
  ${clearFix()}
  background: ${colors.WHITE};
  float: left;
  cursor: pointer;

  &:hover {
    // Even referencing styled components outside component here took forever to get my head around. ;)
    ${ShareShow} {
      display: none;
    }
    ${ShareHidden} {
      display: block;
    }
  }

`;



// WEBPACK FOOTER //
// ./src/components/ShareButtons/style.js